import { Navbar, Nav, Dropdown, Form, Button } from 'react-bootstrap';
import { FaBell, FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface TopbarProps {
  onMenuToggle: () => void;
}

export default function Topbar({ onMenuToggle }: TopbarProps) {
  const navigate = useNavigate();
  const { user, logout: handleLogout } = useAuth();

  const logout = () => {
    handleLogout();
    navigate('/login', { replace: true });
  };

  return (
    <Navbar bg="white" className="px-3 shadow-sm">
      <Button
        variant="link"
        className="d-md-none me-2 p-2"
        onClick={onMenuToggle}
        aria-label="Toggle menu"
        style={{ fontSize: '1.25rem', color: '#333' }}
      >
        <FaBars />
      </Button>
      <Button
        variant="link"
        className="d-none d-md-block me-2 p-2"
        onClick={onMenuToggle}
        aria-label="Toggle menu"
        style={{ fontSize: '1.25rem', color: '#333' }}
      >
        <FaBars />
      </Button>
      <Form className="me-auto">
        <Form.Control type="search" placeholder="Search products, orders..." />
      </Form>
      <Nav className="align-items-center gap-3">
        <Nav.Link aria-label="Notifications">
          <FaBell />
        </Nav.Link>
        <Dropdown align="end">
          <Dropdown.Toggle variant="light">{user?.name || 'Admin'}</Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => navigate('/settings')}>Settings</Dropdown.Item>
            <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Nav>
    </Navbar>
  );
}

